import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

export const ProProfile = styled.div`
  width: 29%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-left: 1px solid ${colors.greyLighter};
  position: relative;
  z-index: 1;
`;

export const HeaderProfile = styled.div`
  width: 100%;
  height: 95px;
  background: ${colors.blueLight2};
  position: relative;
  z-index: 0;
  &:after {
    right: 100%;
    top: 30%;
    border: solid ${colors.greyLighter};
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(246, 249, 255, 0);
    border-right-color: ${colors.blueLight2};
    border-width: 15px;
    margin-top: -15px;
    filter: drop-shadow(-2px 0px 1px rgba(0, 0, 0, 0.15));
  }
`;

export const CardBox = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.greyLighter};
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
`;

export const MainCardBox = styled(CardBox)`
  position: relative;
  z-index: 1;
  width: 90%;
  height: 130px;
  margin: -50px auto 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ProText = styled.p`
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 2px;
`;

export const ProPhoto = styled.img`
  width: 65px;
  height: 65px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 100%;
  margin: -32px auto 0px auto;
  position: relative;
  object-fit: cover;
`;
export const ProName = styled(ProText)`
  font-size: 16px;
  font-weight: 500;
  margin: 7px auto 0;
`;
export const RatingRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 4px auto;
`;
export const RatingCount = styled(ProText)`
  margin: 0 6px;
  font-size: 14px;
`;
export const ProBusiness = styled(ProText)`
  font-size: 14px;
  font-weight: 500;
  margin-top: 3px;
  margin-bottom: 7px;
`;

export const Boxes = styled.div`
  width: 90%;
  margin: 16px auto 0px;
  display: flex;
  justify-content: space-between;
`;
export const ButtonBox = styled(CardBox)`
  background: ${({ disabled }) => (!disabled ? `${colors.white}` : `${colors.greyLight}`)};
  opacity: ${({ disabled }) => (!disabled ? 1 : 0.5)};
  width: 30%;
  min-height: 80px;
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  text-align: center;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: ${({ disabled }) => (!disabled ? '0px 5px 10px rgba(0, 0, 0, 0.25)' : 'none')};
    transition: box-shadow 0.2s;
  }
`;
export const BtnIcon = styled.img`
  width: 28px;
  height: 28px;
  margin: 12px auto 7px;
`;

export const OrderPrice = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
`;

export const InfoBox = styled(CardBox)`
  width: 90%;
  margin: 60px auto 0px auto;
  padding: 5px;
  height: 285px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const OrderText = styled.div`
  margin-top: 9px;
  margin-bottom: 11px;
  font-weight: 500;
  width: 12.9vw;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    text-align: center;
    line-height: 13px;
    color: #565656;
  }
`;

export const OrderLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 50%;
  height: 100%;
  padding-left: 10px;
  p {
    margin-bottom: 0px;
    text-transform: uppercase;
    font-size: 10px;
    line-height: 10px;
    font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
  }
`;

export const OrderLine = styled.div`
  display: flex;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  height: 30px;
  flex-direction: row;
  justify-content: space-between;
  background: ${({ light }) => (light ? '#fff' : '#fafafa')};
`;

export const DescriptionInput = styled.textarea`
  background-color: #fff;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  width: 90%;
  height: 10vh;
  font-size: 10px;
  line-height: 12px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 7px;
`;

export const LinkOrder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 5px;
  button {
    background-color: #fff;
    border: none;
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;

    text-decoration-line: underline;
    color: #565656;
  }
`;

export const OrderTitle = styled.div`
  margin-top: ${({ notAmount }) => (notAmount ? '-5px' : '12px')};
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 20px;
  text-transform: uppercase;
  /* identical to box height */

  align-items: center;

  color: #565656;
`;
export const InfoIcon = styled.div`
  width: 50px;
  min-height: 50px;
  margin: -30px auto 0px;
  border-radius: 100%;
  background: ${colors.white};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const MoneyIcon = styled(InfoIcon)`
  box-shadow: ${({ amount }) => (amount ? `0px 0px 4px ${colors.green}` : `0px 1px 4px ${colors.greyLight}`)};
  img {
    height: 25px;
    width: 28px;
  }
`;
export const HeartIcon = styled(InfoIcon)`
  box-shadow: ${({ favorite }) => (favorite ? `0px 0px 4px ${colors.heart}` : `0px 1px 4px ${colors.greyLight}`)};
  img {
    width: 22px;
    height: 28px;
  }
`;
export const InfoText = styled(ProText)`
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin: 10px auto;
`;
export const PriceText = styled.div`
  width: 35%;
  height: 100%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  p {
    margin-bottom: 0px;
    font-size: 10px;
    font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
    small {
      font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
      margin: 0 auto;
      font-size: 10px;
    }
    strong {
      font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
      margin: 0 auto;
      font-size: ${({ larger }) => (larger ? '14px' : '12px')};
    }
  }

  color: #565656;
`;
export const NotAmountText = styled.div`
  margin-top: 20px;
  margin-bottom: ${({ notAmount }) => notAmount && '35px'};
  height: 60px;
  width: 100%;
  padding-left: 16px; 
  padding-right: 16px;
  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
  }
  display: flex;
  justify-content: center;
`;

export const HireBtn = styled.div`
  width: 60%;
  margin-top: 10px;
  margin-bottom: 15px;
  height: 30px;
  border-radius: 15px;
  background: ${({ backgroundColor }) => {
    switch (backgroundColor) {
      case 'primary':
        return colors.primary;
      case 'greyLight':
        return colors.greyLight;
      case 'red':
        return colors.red;
      default:
        return colors.greyLight;
    }
  }};
  box-shadow: 0px 1px 4px ${colors.greyLight};
  text-align: center;
  color: ${colors.white};
  text-transform: uppercase;
  cursor: ${({ cursor }) => cursor};
  font: 800 0.8vw/30px ${fonts.secondary};
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
`;

export const InvalidatedText = styled.div`
  margin: 10% 5%;
  text-align: center;
  h5 {
    font: 800 15px/30px ${fonts.secondary};
  }
`;
